import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "pdfmake/build/vfs_fonts"

// Set the virtual file system for pdfmake fonts
pdfMake.vfs = pdfFonts.pdfMake.vfs

// Placeholder for CompanyDashboardPDF - replace with your actual implementation
// This function should return a pdfMake document definition
const CompanyDashboardPDF = async (vision: string, mission: string, chartsimage: HTMLAnchorElement) => {
  return {
    content: [
      { text: "Company Dashboard Performance Agreement", style: "header" },
      { text: `Vision: ${vision}`, style: "subheader" },
      { text: `Mission: ${mission}`, style: "subheader" },
      { text: "Charts Image:", style: "subheader" },
      { image: chartsimage.href, width: 500 }, // Use the data URL directly
      { text: "This is a generated PDF for the Company Dashboard.", style: "paragraph" },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
      },
      subheader: {
        fontSize: 14,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      paragraph: {
        margin: [0, 10, 0, 10],
      },
    },
  }
}

export const generateCompanyDashboardPDF = async (vision: string, mission: string, chartsimage: HTMLAnchorElement) => {
  const newWindow = window.open()
  pdfMake.createPdf((await CompanyDashboardPDF(vision, mission, chartsimage)) as any).open({}, newWindow)
}

export const getCompanyDashboardPDFBase64 = async (
  vision: string,
  mission: string,
  chartsimage: HTMLAnchorElement,
): Promise<string> => {
  return new Promise((resolve, reject) => {
    pdfMake.createPdf(CompanyDashboardPDF(vision, mission, chartsimage) as any).getBase64((data: string) => {
      resolve(data)
    })
  })
}
